import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { CheckinResultModel } from '../models/checkinresult.model';
import { CheckinRequestModel } from '../models/checkinrequest.model';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ErrorService } from '../service/error.service';

@Injectable({
  providedIn: 'root'
})
export class CheckinService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  public checkin(checkinrequest: CheckinRequestModel, token: string): Observable<CheckinResultModel> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });
    let options = { headers: headers };
    return this.http.post<CheckinResultModel>(environment.apiUrl + '/checkin', checkinrequest, options)
      .pipe(
        catchError((error: any) => {

          let errorMessage = this.errorService.handleError(error)
          return throwError(() => errorMessage);
        })
      );
  }
  public maskSsn(ssn: string, number?: string): string {
    const visibleDigits = 8;

    let formattedSsn = ssn.length > visibleDigits ? ssn.substring(0, visibleDigits) + 'X'.repeat(ssn.length - visibleDigits) : ssn;
    if (number) {
      formattedSsn = formattedSsn.substring(0, formattedSsn.length - 1) + number;
    }
    if (formattedSsn.length >= 8) {
      formattedSsn = formattedSsn.substring(0, 8) + '-' + formattedSsn.substring(8);
    }
    return formattedSsn;
  }
  public validateSsn(ssn: string): boolean {
    if (!ssn.match(/^(19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|[3][01])\d{4}$/)) {
      return false;
    }
  
    const year = parseInt(ssn.substring(0, 4));
    const month = parseInt(ssn.substring(4, 6)) - 1;
    const day = parseInt(ssn.substring(6, 8));
    const date = new Date(year, month, day);
  
    return date <= new Date() && this.validateSwedishPersonNumber(ssn);
  }
  
  private validateSwedishPersonNumber(ssn: string): boolean {
    const reducedSsn = ssn.substring(2, 12);
    const summary = reducedSsn.split('').reduce((sum, digit, index) => {
      let value = parseInt(digit);
      if (index % 2 === 0) {
        value *= 2;
        if (value > 9) value -= 9;
      }
      return sum + value;
    }, 0);
  
    return summary % 10 === 0;
  }
}
